import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  PayrollGetArrearApplicabilityDetailsResponse,
  PayrollGetArrearApplicabilityDetailsArgs,
} from './types';

const getArrearApplicabilityDetailsQuery = gql`
  query PayrollGetArrearApplicabilityDetails($input: ArrearApplicabilityDetailsInput!) {
    payrollGetArrearApplicabilityDetails(input: $input) {
      code
      success
      message
      data {
        userId
        effectiveDate
        effectivePayrollMonth
        arrearApplicableMonths
        arrearPaymentMonth
      }
    }
  }
`;

export const getArrearApplicabilityDetails = async (
  queryVariables: PayrollGetArrearApplicabilityDetailsArgs,
): Promise<PayrollGetArrearApplicabilityDetailsResponse> => {
  return graphQLApi<
    PayrollGetArrearApplicabilityDetailsResponse,
    PayrollGetArrearApplicabilityDetailsArgs
  >({
    query: getArrearApplicabilityDetailsQuery,
    queryVariables,
  });
};

export default { getArrearApplicabilityDetails };
